import axios from "@/api/config_php";
// import qs from 'qs'

// 登录
export const loginAccount = param => axios.post("/amp/api/v1/login", param);

export const getUserInfoByPandahotspot = () => axios.get("/amp/api/v1/user/getUserInfoByPandahotspot");

// 退出登录
export const loginOut = param => axios.post("/amp/api/v1/logout", param);
// 获取图形验证码图片
export const getCaptchas = param => axios.get("/amp/api/v1/captchas_hhh", param);
// 发送短信验证码接口
export const sendSmsCode = param => axios.post("/amp/api/v1/sendSmsCode", param);
// 注册提交
export const submitRegist = param => axios.post("/amp/api/v1/regStore", param);
// 忘记密码
export const forgetPassStore = param => axios.post("/amp/api/v1/forgetPassStore", param);
// 更换手机号
export const editPhoneStore = param => axios.post("/amp/api/v1/editPhoneStore", param);

// 验证手机号
export const verificationPhone = param => axios.post("/amp/api/v1/user/verificationPhone", param);
// 验证短信验证码
export const authVeriCode = param => axios.post("/amp/api/v1/authVeriCode", param);
// 手机号登录
export const phoneLogin = param => axios.post("/amp/api/v1/phoneLogin", param);

// UV
export const marketingUV = param => axios.post("/amp/api/v1/addMarketingUV", param);
// 确认客户协议
export const confirmAgreement = param => axios.post("/amp/api/v1/client/confirmAgreement", param);

//获取用户职位列表
export const getPositionLists = param => axios.get("/amp/api/v1/positionLists", param);
//设置用户职位
export const setUserPosition = param => axios.post("/amp/api/v1/miniprogram/setUserPosition", param);